// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"97":"f9efe448","152":"def7a68f","277":"9c106a4b"}[chunkId] + ".chunk.css";
};